import { z } from "zod";

export const IPStateSchema = z.object({
  ip_type: z.string(),
  asset: z.string(),
  state: z.number(),
  maintenance_level: z.number(),
  component: z.string(),
  description: z.string(),
  subsystem: z.string(),
});

export type IPStateType = z.infer<typeof IPStateSchema>;

export const AssetStateSchema = z.object({
  hms1_criticality: z.number(),
  hms3_criticality: z.number(),
  dr_criticality: z.number(),
  id: z.number(),
  ip_type: z.string(),
  asset: z.string(),
  state: z.number(),
  maintenance_level: z.number(),
  component: z.string(),
  description: z.string(),
  subsystem: z.string(),
  assetgroup: z.string(),
  external_reference_id: z.string(),
  zone: z.number(),
  cost_component: z.number(),
  cost_resource: z.number(),
  cost_logistic: z.number(),
  man_hours_required: z.number(),
  lifespan_years: z.number(),
  comment: z.string(),
  inspection_date: z.string().nullable(),
});

export type AssetStateType = z.infer<typeof AssetStateSchema>;
